export default "__VITE_ASSET__ChfHsTY2__"